<section class="pt-8">
  <div class="flex items-baseline gap-2.5 pb-3">
    <h2 class="text-base font-bold tracking-[-0.01em] text-foreground">Aktive Kampagnen</h2>
    @if (!isLoading()) {
      <span class="font-mono text-2xs text-muted-foreground">{{ campaigns().length }} laufend</span>
    }
    <button
      type="button"
      (click)="openAll()"
      class="ml-auto font-mono text-2xs text-muted-foreground transition-colors hover:text-primary"
    >
      Alle
    </button>
  </div>

  <div class="border-t border-border grid gap-x-10 md:grid-cols-2 lg:grid-cols-3">
    @if (isLoading()) {
      @for (i of [1, 2, 3]; track i) {
        <div class="pt-4 flex flex-col gap-3">
          <div class="h-3.5 w-2/3 rounded bg-muted animate-pulse"></div>
          <div class="h-[5px] w-full rounded-full bg-muted animate-pulse"></div>
          <div class="h-3 w-1/2 rounded bg-muted animate-pulse"></div>
        </div>
      }
    } @else if (loadError()) {
      <p class="py-4 text-sm text-muted-foreground">Kampagnen konnten nicht geladen werden.</p>
    } @else {
      @for (c of campaigns(); track c.id) {
        <button
          type="button"
          (click)="open(c)"
          [title]="absoluteTime(c.updatedAt)"
          class="group pt-4 pb-1 text-left"
        >
          <div class="flex items-baseline gap-2">
            <span class="flex-1 min-w-0 truncate text-sm font-normal text-foreground transition-colors group-hover:text-primary">
              {{ c.title }}
            </span>
            <span class="flex-none font-mono text-2xs text-muted-foreground">{{ relativeTime(c.updatedAt) }}</span>
          </div>
          <div class="flex h-[5px] gap-px my-3 rounded-full overflow-hidden bg-muted">
            @for (segment of segments(c); track segment.label) {
              <span class="h-full" [class]="segment.colorClass" [style.width.%]="segment.percent"></span>
            }
          </div>
          <div class="truncate font-mono text-2xs text-muted-foreground">{{ summary(c) }}</div>
        </button>
      } @empty {
        <p class="py-4 text-sm text-muted-foreground">Aktuell keine laufenden Kampagnen.</p>
      }
    }
  </div>
</section>
